module.exports = __webpack_public_path__ + "static/media/hexaEmptyLight.7fc30789.svg";